import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import LoginPage from "./components/Login/LoginPage";
import Signup from "./components/Login/Signup";
import ProtectedAssessment from "./components/ProtectedAssessment";
import AssessmentTest from "./components/pages/AssessmentTest";
import NotFoundPage from "./components/pages/NotFoundPage";
import ThankyouPage from "./components/pages/ThankyouPage";
import LandingPage from "./components/pages/LandingPage";
import ThankyouPageIndividual from "./components/pages/ThankyouPageIndividual";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* <Route path='/test' element={<LoginPage />} /> */}
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/test" element={<Signup />} />

        {/* <Route path="/test" element={<ProtectedAssessment/>}/> */}
        <Route path="/assessment" element={<AssessmentTest />} />
        <Route path="/thank-you" element={<ThankyouPage />} />
        <Route path="/thank-you-individual" element={<ThankyouPageIndividual />} />
      </Routes>
    </div>
  );
}

export default App;
